import {saveData} from './resource'

export const apiUrlRatings = '/v2/mail-subscribes/'

export function saveMailSubscription(data: {email: string|null, acceptToSA?: boolean}): Promise<any> {
  return saveData(apiUrlRatings, data);
}
